import React from "react";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Stats } from "./components/Stats";
import { Story } from "./components/Story";
import { Program } from "./components/Program";
import { Testimonials } from "./components/Testimonials";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
export function App() {
  return <div className="min-h-screen w-full bg-ink font-sans text-white" data-id="element-0" data-mp="2rl6y5e9xj6xz">
      <Nav data-id="element-1" data-mp="2mn5bykh7iria" />
      <main data-id="element-2" data-mp="2mndryl8mmcxp">
        <Hero data-id="element-3" data-mp="2mjpuxc3z38e8" />
        <Stats data-id="element-4" data-mp="2mjzmv58kvpmk" />
        <Story data-id="element-5" data-mp="31agoopp4khjz" />
        <Program data-id="element-6" data-mp="31ayrk56alu0v" />
        <Testimonials data-id="element-7" data-mp="31bic7tnbuwil" />
        <Faq data-id="element-8" data-mp="31c1ksjr388jy" />
        <FinalCta data-id="element-9" data-mp="31cjog1g2xp1w" />
      </main>
      <Footer data-id="element-10" data-mp="2wjgq7g0cxrfd" />
    </div>;
}